<template>
	<div>
		<google-map />
	</div>   
</template>

<script>
import GoogleMap from '@/components/GoogleMap'
import { eventBus } from './../main'
export default {
	components: {
		GoogleMap
	},
	data() {
		return {
			
		}
	},
	created(){
		eventBus.$emit('showHeaderFooterEvent', false);
	},
	methods: {
		
	}
}
</script>
<style>
	.google-map, .store-list{
		height: 95vh !important;
		max-height: 600px;
	}

	.map-container{
		margin-right: 0px;
	}
</style>